import firebase from '@firebase/app';
import '@firebase/auth';
import '@firebase/database';
import '@firebase/storage';

firebase.initializeApp({
  apiKey: 'AIzaSyCwa6n0-5lI2qrW2M5xxZnLAk2jjQWV9dY',
  authDomain: 'cryo-turku.firebaseapp.com',
  databaseURL: 'https://cryo-turku.firebaseio.com',
  projectId: 'cryo-turku',
  storageBucket: 'cryo-turku.appspot.com',
  messagingSenderId: '151946536820',
  appId: '1:151946536820:web:56174e463fe0586bfc2e21',
});

export default firebase;
